export default __webpack_public_path__ + "static/media/question-white.1e48fd61.svg";